import { Box, Button, Flex, FormControl, Input } from "@chakra-ui/react"
import React from "react"
import useForm from "../Hooks/useForm"

import { loginForm } from "../Types/Form"
import { baseUrl } from "../settings"
import { TokenContext } from "../App"
import { useContext } from 'react'
import { useNavigate } from "react-router-dom"
import Navbar from "../Navbar/Navbar"

import { useToast } from '@chakra-ui/react'



function validateEmail(email: string) 
{
    let re = /\S+@\S+\.\S+/;
    return re.test(email);
}

const StandardSignIn = () => {

    // @ts-ignore
    const { token , setToken } = useContext(TokenContext)
    let navigate = useNavigate()
    const toast = useToast()

    const [form, setForm ] = useForm({"usernameOrEmail": "", "password": ""}) as [loginForm, Function]

const loginRequest = (e: any, loginDetails: loginForm) => {
        e.preventDefault()
        const url = baseUrl + '/auth/login/';
        var data;
        if(validateEmail(loginDetails.usernameOrEmail)) {
            data = {"email": loginDetails.usernameOrEmail, "password": loginDetails.password}
        }
        else {
            data = {"username": loginDetails.usernameOrEmail, "password": loginDetails.password}
        }

        fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data) 
        })
        .then(response => response.json())
        .then(data => {
            if(!data.hasOwnProperty('key'))
            {
                throw new Error('Invalid Username/Email or Password');
            }
            setToken(data.key)
            toast({
                position:'top-right',
                title: 'Login Success',
                description: "You have successfully logged in",
                status: 'success',
                duration: 9000,
                isClosable: true,
            })
            navigate(-1)
        })
        .catch(err => alert(err))
    }

    const handleGuestLogin = (e: any) => {
        e.preventDefault();
        const url = baseUrl + '/auth/login/';
        fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({username: 'root', password: 'root'}) 
        })
        .then(response => response.json())
        .then(data => {
            if(!data.hasOwnProperty('key'))
            {
                throw new Error('Invalid Username/Email or Password');
            }
            setToken(data.key)
            toast({
                position:'top-right',
                title: 'Logged In',
                description: `You are successfully logged in`,
                status: 'success',
                duration: 9000,
                isClosable: true,
            })
            navigate(-1)
        })
        .catch(err => alert(err))
    }

    return (
        <>
        <Flex width={"100%"} flexDirection={"column"} alignItems={"center"}>
            <FormControl id="user-login-form" as="form">
                <Flex direction="column" justifyContent={"center"} alignItems={"center"}>
                    <Input margin={"1rem"} placeholder="Username/Email" value={form.usernameOrEmail} name="usernameOrEmail" 
                    onChange={(e) => setForm(e)} id="username-email"></Input>

                    <Input margin={"1rem"} placeholder="Password" value={form.password} name="password" type="password"
                    onChange={(e) => setForm(e)} id="login-password" autoComplete="on"></Input>
                </Flex>
                <Box textAlign="center" margin={"1rem"} display={"flex"} justifyContent={"space-evenly"}>
                    <Button width={"10rem"} type="submit" onClick={(e) => loginRequest(e, form)}>Login</Button>
                    <Button width={"10rem"} type="submit" onClick={(e) => handleGuestLogin(e)}>Guest Login</Button>
                </Box>
            </FormControl>   
        </Flex>
        </>     
    )
}

export default StandardSignIn
